import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import Reveal from "@/components/Reveal";
import { FAQS } from "@/lib/site";
import { withBoldComingSoon } from "@/lib/textFormat";

// FAQPage JSON-LD for Google rich-result eligibility.
// Computed at module scope (not per render) and `</` is escaped to `<\/`
// so any future FAQ copy that contains the literal sequence "</script>" or
// "</style>" can't break out of the inline <script> tag.
const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};
const faqSchemaHtml = {
  __html: JSON.stringify(faqSchema).replace(/<\//g, "<\\/"),
};

export default function FAQ() {
  return (
    <section className="max-w-5xl mx-auto px-6 md:px-10 py-24 md:py-32" data-testid="faq-section">
      <script type="application/ld+json" dangerouslySetInnerHTML={faqSchemaHtml} />
      <Reveal className="text-center max-w-2xl mx-auto mb-16">
        <div className="overline">Good to know</div>
        <h2 className="font-serif text-4xl sm:text-5xl tracking-tight leading-tight mt-4">
          Caravan park Ballarat — <em className="italic font-light">your questions, answered.</em>
        </h2>
      </Reveal>
      <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
        {FAQS.map((f, i) => (
          <AccordionItem key={f.q} value={`item-${i}`} className="border-b border-sa-ink/15">
            <AccordionTrigger
              className="font-serif text-lg md:text-xl tracking-tight py-6 hover:no-underline text-sa-ink"
              data-testid={`faq-q-${i}`}
            >
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-sa-ink2 text-base leading-relaxed pb-6 max-w-3xl">
              {withBoldComingSoon(f.a)}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
